@if (avatars().length > 0) {
  <ng-container *transloco="let t; scope: 'uiComponents'">
    <p-button
      data-id="avatar-group-toggle-button"
      styleClass="bd-toolbar-button bd-round-left bd-avatar-group-button {{
        avatarGroupMenuComponentStore.isPopoverOpened() ? 'bd-active' : ''
      }}"
      [icon]="avatarGroupMenuComponentStore.chevronIcon()"
      iconPos="right"
      [text]="true"
      [attr.aria-label]="t('uiComponents.collaboration.avatarGoupMenuInfo')"
      [pTooltip]="t('uiComponents.collaboration.avatarGoupMenuInfo')"
      tooltipPosition="bottom"
      [showDelay]="500"
      (onClick)="avatarsPopover.toggle($event)"
    >
      <bd-avatar-group [avatars]="avatars()"></bd-avatar-group>
    </p-button>

    <p-popover
      #avatarsPopover
      (onShow)="avatarGroupMenuComponentStore.setIsPopoverOpened(true)"
      (onHide)="avatarGroupMenuComponentStore.setIsPopoverOpened(false)"
      styleClass="bd-popover-positioning bd-popover-rounded"
    >
      <div
        class="bd-avatar-popover bd-small-scrollbar"
        data-id="avatar-popover"
        bdNoScroll
      >
        <div class="bd-avatars-popover-header">
          <p>{{ t('uiComponents.menu.showCursors') }}</p>
          <p-toggleSwitch
            [(ngModel)]="areCursorsVisible"
            ariaLabel="Avatar group switch"
            (onChange)="toggleCursorsVisibility.emit($event.checked)"
          />
        </div>
        <div class="bd-users-list gap-4">
          @if (avatars(); as avatars) {
            @for (avatar of avatars; track avatar.clientId) {
              <bd-user-card [bdAvatar]="avatar" tabindex="-1"></bd-user-card>
            }
          }
        </div>
      </div>
    </p-popover>
  </ng-container>
}
